import React, { useCallback, useEffect, useState } from "react";
import { withStyles } from "@mui/styles";
import { Route, Switch, useHistory, useParams, useRouteMatch } from "react-router-dom";

import { getUsers } from "../../api/user";
import { Header } from "../../components";
import AuditLogs from "../../containers/AuditLogs";
import { getOrganizations } from "../../api/organization";
import UsersTable from "../../components/Users/UsersTable";
import TokensTable from "../../components/Tokens";
import { BodyContainer } from "../../components/BaseComponents";

const styles = () => ({
  paper: {
    width: 1080,
    margin: "auto",
    overflow: "hidden",
    boxShadow: "0 1px 3px 0 #dce1e6",
    borderRadius: "5px"
  }
});

const tabs = [
  {
    label: "Users",
    id: "users"
  },
  {
    label: "Tokens",
    id: "tokens"
  },
  {
    label: "Analytics",
    id: "analytics"
  }
];

function OrganizationDetail(props) {
  const { orgId } = useParams();
  const { url } = useRouteMatch();
  const history = useHistory();

  const [organization, setOrganization] = useState(null);

  const fetchOrganization = useCallback(
    (orgId) => {
      getOrganizations([orgId]).then((organizations) => {
        const organization = organizations.filter((o) => o.id === orgId)[0];
        if (!organization) {
          history.push("/organizations");
        } else {
          setOrganization(organization);
        }
      });
    },
    [history]
  );

  useEffect(() => {
    fetchOrganization(orgId);
    getUsers({ organizationId: orgId });
  }, [orgId, fetchOrganization]);

  if (!organization?.id) return null;

  return (
    <>
      <Header
        rootUrl={url}
        defaultTab={"users"}
        tabs={tabs}
        headerTitle={organization?.name}
        headerSecondaryTitle={organization?.id}
        onDrawerToggle={props.onDrawerToggle}
      />
      <BodyContainer tabbedLayout={true}>
        <Switch>
          <Route
            exact
            path={`/organizations/:orgId/${tabs[0].id}`}
            render={(props) => <UsersTable {...props} organizationId={organization?.id} />}
          />

          <Route
            exact
            path={`/organizations/:orgId/${tabs[1].id}`}
            render={(props) => <TokensTable {...props} organizationId={organization?.id} />}
          />

          <Route
            exact
            path={`/organizations/:orgId/${tabs[2].id}`}
            render={(props) => <AuditLogs {...props} isHeaderHidden={true} organizationId={organization?.id} />}
          />
        </Switch>
      </BodyContainer>
    </>
  );
}

export default withStyles(styles)(OrganizationDetail);
